import { Link } from '@phosphor-icons/react';
import { SearchWebPageReference } from 'src/types';

const ICON_SIZE = 16;

interface ResearchReferenceProps extends SearchWebPageReference {
  index: number;
  onClick: (index: number) => void;
}

export const ResearchReference = ({
  url,
  title,
  favicon,
  source,
  index,
}: ResearchReferenceProps) => {
  return (
    <div className="nj-thread-research-card--reference-item">
      <a
        className="nj-thread-research-card--reference-link"
        title={title}
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        <div className="nj-thread-research-card--reference-header">
          <span className="nj-thread-research-card--reference-item-index">
            {index + 1}
          </span>

          {favicon ? (
            <img src={favicon} alt={title} height={ICON_SIZE} />
          ) : (
            <Link size={ICON_SIZE} />
          )}

          <p className="nj-thread-research-card--reference-item-title">
            {source || `Web Source`}
          </p>
        </div>
      </a>
    </div>
  );
};
